module.exports = __webpack_public_path__ + "img/bj-2.8acef314.png";